/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProjectProjectIdIndexRouteImport } from './routes/project.$projectId.index'
import { Route as ProjectProjectIdTrashRouteImport } from './routes/project.$projectId.trash'
import { Route as ProjectProjectIdTakeoffTakeoffIdIndexRouteImport } from './routes/project.$projectId.takeoff.$takeoffId.index'
import { Route as ProjectProjectIdTakeoffTakeoffIdWorkPackagesRouteImport } from './routes/project.$projectId.takeoff.$takeoffId.work-packages'
import { Route as ProjectProjectIdTakeoffTakeoffIdQuantitiesRouteImport } from './routes/project.$projectId.takeoff.$takeoffId.quantities'
import { Route as ProjectProjectIdTakeoffTakeoffIdProductsRouteImport } from './routes/project.$projectId.takeoff.$takeoffId.products'
import { Route as ProjectProjectIdTakeoffTakeoffIdDrawingFileIdRouteImport } from './routes/project.$projectId.takeoff.$takeoffId.drawing.$fileId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectProjectIdIndexRoute = ProjectProjectIdIndexRouteImport.update({
  id: '/project/$projectId/',
  path: '/project/$projectId/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectProjectIdTrashRoute = ProjectProjectIdTrashRouteImport.update({
  id: '/project/$projectId/trash',
  path: '/project/$projectId/trash',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectProjectIdTakeoffTakeoffIdIndexRoute =
  ProjectProjectIdTakeoffTakeoffIdIndexRouteImport.update({
    id: '/project/$projectId/takeoff/$takeoffId/',
    path: '/project/$projectId/takeoff/$takeoffId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProjectProjectIdTakeoffTakeoffIdWorkPackagesRoute =
  ProjectProjectIdTakeoffTakeoffIdWorkPackagesRouteImport.update({
    id: '/project/$projectId/takeoff/$takeoffId/work-packages',
    path: '/project/$projectId/takeoff/$takeoffId/work-packages',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProjectProjectIdTakeoffTakeoffIdQuantitiesRoute =
  ProjectProjectIdTakeoffTakeoffIdQuantitiesRouteImport.update({
    id: '/project/$projectId/takeoff/$takeoffId/quantities',
    path: '/project/$projectId/takeoff/$takeoffId/quantities',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProjectProjectIdTakeoffTakeoffIdProductsRoute =
  ProjectProjectIdTakeoffTakeoffIdProductsRouteImport.update({
    id: '/project/$projectId/takeoff/$takeoffId/products',
    path: '/project/$projectId/takeoff/$takeoffId/products',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProjectProjectIdTakeoffTakeoffIdDrawingFileIdRoute =
  ProjectProjectIdTakeoffTakeoffIdDrawingFileIdRouteImport.update({
    id: '/project/$projectId/takeoff/$takeoffId/drawing/$fileId',
    path: '/project/$projectId/takeoff/$takeoffId/drawing/$fileId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/project/$projectId/trash': typeof ProjectProjectIdTrashRoute
  '/project/$projectId/': typeof ProjectProjectIdIndexRoute
  '/project/$projectId/takeoff/$takeoffId/products': typeof ProjectProjectIdTakeoffTakeoffIdProductsRoute
  '/project/$projectId/takeoff/$takeoffId/quantities': typeof ProjectProjectIdTakeoffTakeoffIdQuantitiesRoute
  '/project/$projectId/takeoff/$takeoffId/work-packages': typeof ProjectProjectIdTakeoffTakeoffIdWorkPackagesRoute
  '/project/$projectId/takeoff/$takeoffId/': typeof ProjectProjectIdTakeoffTakeoffIdIndexRoute
  '/project/$projectId/takeoff/$takeoffId/drawing/$fileId': typeof ProjectProjectIdTakeoffTakeoffIdDrawingFileIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/project/$projectId/trash': typeof ProjectProjectIdTrashRoute
  '/project/$projectId': typeof ProjectProjectIdIndexRoute
  '/project/$projectId/takeoff/$takeoffId/products': typeof ProjectProjectIdTakeoffTakeoffIdProductsRoute
  '/project/$projectId/takeoff/$takeoffId/quantities': typeof ProjectProjectIdTakeoffTakeoffIdQuantitiesRoute
  '/project/$projectId/takeoff/$takeoffId/work-packages': typeof ProjectProjectIdTakeoffTakeoffIdWorkPackagesRoute
  '/project/$projectId/takeoff/$takeoffId': typeof ProjectProjectIdTakeoffTakeoffIdIndexRoute
  '/project/$projectId/takeoff/$takeoffId/drawing/$fileId': typeof ProjectProjectIdTakeoffTakeoffIdDrawingFileIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/project/$projectId/trash': typeof ProjectProjectIdTrashRoute
  '/project/$projectId/': typeof ProjectProjectIdIndexRoute
  '/project/$projectId/takeoff/$takeoffId/products': typeof ProjectProjectIdTakeoffTakeoffIdProductsRoute
  '/project/$projectId/takeoff/$takeoffId/quantities': typeof ProjectProjectIdTakeoffTakeoffIdQuantitiesRoute
  '/project/$projectId/takeoff/$takeoffId/work-packages': typeof ProjectProjectIdTakeoffTakeoffIdWorkPackagesRoute
  '/project/$projectId/takeoff/$takeoffId/': typeof ProjectProjectIdTakeoffTakeoffIdIndexRoute
  '/project/$projectId/takeoff/$takeoffId/drawing/$fileId': typeof ProjectProjectIdTakeoffTakeoffIdDrawingFileIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/project/$projectId/trash'
    | '/project/$projectId/'
    | '/project/$projectId/takeoff/$takeoffId/products'
    | '/project/$projectId/takeoff/$takeoffId/quantities'
    | '/project/$projectId/takeoff/$takeoffId/work-packages'
    | '/project/$projectId/takeoff/$takeoffId/'
    | '/project/$projectId/takeoff/$takeoffId/drawing/$fileId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/project/$projectId/trash'
    | '/project/$projectId'
    | '/project/$projectId/takeoff/$takeoffId/products'
    | '/project/$projectId/takeoff/$takeoffId/quantities'
    | '/project/$projectId/takeoff/$takeoffId/work-packages'
    | '/project/$projectId/takeoff/$takeoffId'
    | '/project/$projectId/takeoff/$takeoffId/drawing/$fileId'
  id:
    | '__root__'
    | '/'
    | '/project/$projectId/trash'
    | '/project/$projectId/'
    | '/project/$projectId/takeoff/$takeoffId/products'
    | '/project/$projectId/takeoff/$takeoffId/quantities'
    | '/project/$projectId/takeoff/$takeoffId/work-packages'
    | '/project/$projectId/takeoff/$takeoffId/'
    | '/project/$projectId/takeoff/$takeoffId/drawing/$fileId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProjectProjectIdTrashRoute: typeof ProjectProjectIdTrashRoute
  ProjectProjectIdIndexRoute: typeof ProjectProjectIdIndexRoute
  ProjectProjectIdTakeoffTakeoffIdProductsRoute: typeof ProjectProjectIdTakeoffTakeoffIdProductsRoute
  ProjectProjectIdTakeoffTakeoffIdQuantitiesRoute: typeof ProjectProjectIdTakeoffTakeoffIdQuantitiesRoute
  ProjectProjectIdTakeoffTakeoffIdWorkPackagesRoute: typeof ProjectProjectIdTakeoffTakeoffIdWorkPackagesRoute
  ProjectProjectIdTakeoffTakeoffIdIndexRoute: typeof ProjectProjectIdTakeoffTakeoffIdIndexRoute
  ProjectProjectIdTakeoffTakeoffIdDrawingFileIdRoute: typeof ProjectProjectIdTakeoffTakeoffIdDrawingFileIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/project/$projectId/': {
      id: '/project/$projectId/'
      path: '/project/$projectId'
      fullPath: '/project/$projectId/'
      preLoaderRoute: typeof ProjectProjectIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/project/$projectId/trash': {
      id: '/project/$projectId/trash'
      path: '/project/$projectId/trash'
      fullPath: '/project/$projectId/trash'
      preLoaderRoute: typeof ProjectProjectIdTrashRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/project/$projectId/takeoff/$takeoffId/': {
      id: '/project/$projectId/takeoff/$takeoffId/'
      path: '/project/$projectId/takeoff/$takeoffId'
      fullPath: '/project/$projectId/takeoff/$takeoffId/'
      preLoaderRoute: typeof ProjectProjectIdTakeoffTakeoffIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/project/$projectId/takeoff/$takeoffId/work-packages': {
      id: '/project/$projectId/takeoff/$takeoffId/work-packages'
      path: '/project/$projectId/takeoff/$takeoffId/work-packages'
      fullPath: '/project/$projectId/takeoff/$takeoffId/work-packages'
      preLoaderRoute: typeof ProjectProjectIdTakeoffTakeoffIdWorkPackagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/project/$projectId/takeoff/$takeoffId/quantities': {
      id: '/project/$projectId/takeoff/$takeoffId/quantities'
      path: '/project/$projectId/takeoff/$takeoffId/quantities'
      fullPath: '/project/$projectId/takeoff/$takeoffId/quantities'
      preLoaderRoute: typeof ProjectProjectIdTakeoffTakeoffIdQuantitiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/project/$projectId/takeoff/$takeoffId/products': {
      id: '/project/$projectId/takeoff/$takeoffId/products'
      path: '/project/$projectId/takeoff/$takeoffId/products'
      fullPath: '/project/$projectId/takeoff/$takeoffId/products'
      preLoaderRoute: typeof ProjectProjectIdTakeoffTakeoffIdProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/project/$projectId/takeoff/$takeoffId/drawing/$fileId': {
      id: '/project/$projectId/takeoff/$takeoffId/drawing/$fileId'
      path: '/project/$projectId/takeoff/$takeoffId/drawing/$fileId'
      fullPath: '/project/$projectId/takeoff/$takeoffId/drawing/$fileId'
      preLoaderRoute: typeof ProjectProjectIdTakeoffTakeoffIdDrawingFileIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProjectProjectIdTrashRoute: ProjectProjectIdTrashRoute,
  ProjectProjectIdIndexRoute: ProjectProjectIdIndexRoute,
  ProjectProjectIdTakeoffTakeoffIdProductsRoute:
    ProjectProjectIdTakeoffTakeoffIdProductsRoute,
  ProjectProjectIdTakeoffTakeoffIdQuantitiesRoute:
    ProjectProjectIdTakeoffTakeoffIdQuantitiesRoute,
  ProjectProjectIdTakeoffTakeoffIdWorkPackagesRoute:
    ProjectProjectIdTakeoffTakeoffIdWorkPackagesRoute,
  ProjectProjectIdTakeoffTakeoffIdIndexRoute:
    ProjectProjectIdTakeoffTakeoffIdIndexRoute,
  ProjectProjectIdTakeoffTakeoffIdDrawingFileIdRoute:
    ProjectProjectIdTakeoffTakeoffIdDrawingFileIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
